import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "de"],
    fallbackLng: "de",
    detection: {
      order: ["cookie", "localStorage"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
    // React escapes everything it renders, so i18next escaping on top of that
    // only corrupts real text: a board named "PAS/HES" reached the screen as
    // "PAS&#x2F;HES".
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
